export default __webpack_public_path__ + "static/img_3_0-001fc3e30817d8f4269cc19892413ac4.jpg";